import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Concepto 2: Señal con reveal secuencial
// Las tres frases aparecen en cadena con 1.2s de pausa entre ellas.
// El efecto es de conversación, no de animación.
const phraseVariants = {
  hidden: {
    opacity: 0,
    y: 12
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: 'easeOut'
    }
  }
};
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 1.2
    }
  }
};
export function SignalSection() {
  return <section className="bg-gradient-section px-5 md:px-8" style={{
    padding: '7rem 0'
  }} data-id="element-319">
      <div className="max-w-2xl mx-auto" data-id="element-320">
        {/* Eyebrow — pequeño, sutil */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="uppercase tracking-[0.28em] text-[#C8A870] font-semibold mb-14 text-[11px] text-center" style={{
        fontFamily: 'sans-serif'
      }} data-id="element-321">
          Lo que está pasando
        </motion.p>

        {/* Bloque de frases secuenciales */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.4
      }} className="text-left md:text-center" data-id="element-322">
          {/* Frase 1 — la más grande */}
          <motion.h2 variants={phraseVariants} className="font-display font-semibold text-[#F0E8D8] leading-[1.08] tracking-tight" style={{
          fontSize: 'clamp(34px, 7vw, 54px)',
          marginBottom: '0.2em'
        }} data-id="element-323">
            Tu cuerpo
            <br data-id="element-324" />
            no falló.
          </motion.h2>

          {/* Espacio visual entre frases */}
          <div style={{
          height: '1.6em'
        }} data-id="element-325" />

          {/* Frase 2 — gold italic */}
          <motion.p variants={phraseVariants} className="font-display italic text-gradient-gold leading-[1.1]" style={{
          fontSize: 'clamp(30px, 6vw, 48px)',
          marginBottom: '0.2em'
        }} data-id="element-326">
            Cambió la señal.
          </motion.p>

          {/* Espacio visual */}
          <div style={{
          height: '1.6em'
        }} data-id="element-327" />

          {/* Frase 3 — pequeña, apagada */}
          <motion.p variants={phraseVariants} className="font-display text-[#F0E8D8]/55" style={{
          fontSize: 'clamp(18px, 3.5vw, 26px)'
        }} data-id="element-328">
            Y nadie te enseñó a leerla.
          </motion.p>
        </motion.div>

        {/* Párrafo explicativo — aparece después */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="mt-16 font-body text-[#F0E8D8]/60 max-w-lg text-center mx-auto" style={{
        fontSize: 'clamp(15px, 2.5vw, 18px)',
        lineHeight: 1.7
      }} data-id="element-329">
          los cambios hormonales hacen que lo que antes funcionaba ya no
          alcance. H·E·R fue diseñado para acompañar esta etapa de forma simple
          y sostenible.
        </motion.p>

        <div className="divider-fine w-16 mx-auto mt-16" data-id="element-330" />
      </div>
    </section>;
}